import React from 'react';
import arrowLeftIcon from 'assets/images/arrow-left.png';
import { Text, TextVariant } from 'components/Typography/Text';
import { Color } from 'utils/color';
import style from './BackWithTitle.scss';

interface Props {
  title: string;
  onClick: () => void;
  textVariant?: TextVariant;
  textColor?: string;
}

const BackWithTitle: React.FC<Props> = ({ title, onClick, textVariant = 'sm', textColor = Color.DARK_BLUE_NEW }): JSX.Element => (
  <div className={style.container} onClick={onClick}>
    <img src={arrowLeftIcon} className={style.backIcon} alt="back arrow" />
    <Text variant={textVariant} color={textColor}>
      {title}
    </Text>
  </div>
);

export default BackWithTitle;
